import { MessageCircle, MonitorSmartphone, User } from "lucide-react";
import SectionHead from "@/components/SectionHead";
import LeadForm from "@/components/LeadForm";
import { CONTACT, WHATSAPP_DISPLAY, waLink, MESSAGES } from "@/data/site";
import { useLang } from "@/i18n";

const Contact = () => {
  const t = useLang().t;
  return (
  <section id="contact" data-testid="contact" className="bg-[#FDFBF7] py-16 sm:py-24">
    <div className="container-site">
      <SectionHead
        testId="contact-head"
        eyebrow={t.contact.eyebrow}
        title={t.contact.title}
        sub={t.contact.sub}
      />
      <div className="mt-12 grid gap-8 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <div className="card-site h-full p-6 sm:p-8">
            <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[#F5F2EB]">
              <User className="h-7 w-7 text-[#A88667]" />
            </div>
            <h3 className="mt-5 font-heading text-2xl font-bold text-[#3E2723]">{CONTACT.name}</h3>
            <p className="mt-1 text-sm font-medium text-[#8D6E63]">{CONTACT.role}</p>
            <p className="mt-5 text-sm sm:text-base leading-relaxed text-[#5D4037]">
              {t.contact.intro}
            </p>
            <p className="mt-4 font-heading text-lg font-bold text-[#3E2723]" data-testid="contact-whatsapp-number">
              {t.contact.whatsappLabel} {WHATSAPP_DISPLAY}
            </p>
            <div className="mt-6 space-y-3">
              <a
                href={waLink(MESSAGES.generic)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-whatsapp-btn"
                className="btn-whatsapp w-full"
              >
                <MessageCircle className="h-4 w-4" /> {t.contact.chat}
              </a>
              <a href="#demos" data-testid="contact-demo-btn" className="btn-outline w-full">
                <MonitorSmartphone className="h-4 w-4" /> {t.contact.requestDemo}
              </a>
            </div>
          </div>
        </div>
        <div className="lg:col-span-3">
          <LeadForm />
        </div>
      </div>
    </div>
  </section>
  );
};

export default Contact;
